export var theme = {
    container: {
        display: 'flex',
        flexDirection: 'column',
        rowGap: 1,
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: 2,
    },
    enableSubscriptionContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        rowGap: 2,
        alignItems: 'center',
    },
    infoAlertStyles: {
        display: 'flex',
        flexDirection: 'column',
        fontSize: '16px',
        width: '100%',
        minWidth: '100%',
    },
};
